import { useCallback } from 'react';

import { useFormPrompt } from 'hooks';
import { useFormContext } from 'modules/operation/common/forms/operationForm';

import { useOperationContext } from '../providers/OperationProvider';

export const useToggleEditable = () => {
  const { onDisableEdit, onEnableEdit } = useOperationContext();
  const { readOnly, setReadOnly } = useFormContext();
  const { confirmIsChanged } = useFormPrompt();

  const disableEditable = useCallback(() => {
    const callback = () => setReadOnly(true);
    return confirmIsChanged(() => onDisableEdit(callback));
  }, [confirmIsChanged, onDisableEdit, setReadOnly]);

  const enableEditable = useCallback(() => {
    onEnableEdit(() => setReadOnly(false));
  }, [onEnableEdit, setReadOnly]);

  return {
    editable: !readOnly,
    disableEditable,
    enableEditable,
  };
};
